
const Index = () => import(/* webpackChunkName: "invoice" */ "./index");
const DueInvoice = () => import(/* webpackChunkName: "invoice" */ "./DueInvoice");
const RefundInvoice = () => import(/* webpackChunkName: "invoice" */ "./RefundInvoice");
const ProductInvoice = () => import(/* webpackChunkName: "invoice" */ "./ProductInvoice");
const CampaignInvoice = () => import(/* webpackChunkName: "invoice" */ "./CampaignInvoice");
const OpenInvoices = () => import(/* webpackChunkName: "invoice" */ "./OpenInvoices");
const DonationCategoryInvoice = () => import(/* webpackChunkName: "invoice" */ "./DonationCategoryInvoice");

export default [{
  path: 'invoice',
  name: 'invoice-report',
  component: Index,
  redirect: {
    name: 'due-invoice'
  },
  children: [{
      path: 'due',
      name: 'due-invoice',
      component: DueInvoice,
    },
    {
      path: 'refundInvoice',
      name: 'refund-invoice',
      component: RefundInvoice,
    },
    {
      path: 'openInvoice',
      name: 'open-invoice',
      component: OpenInvoices,
    },
    {
      path: 'byProduct',
      name: 'byProduct',
      component: ProductInvoice,
    },
    {
      path: 'byCampaign',
      name: 'byCampaign',
      component: CampaignInvoice,
    },
    {
      path: 'byDonationCategory',
      name: 'byDonationCategory',
      component: DonationCategoryInvoice,
    }],
}, ]